<template>
  <div
    :ref="`${game.id}${reff}`"
    :class="
      !bidLadderSpread
        ? 'select-popup py-1 container'
        : 'select-popup-bidladder py-1 container'
    "
    @click.stop
  >
    <div class="row">
      <div class="col-6 nameTeam">
        {{ leftName }}
      </div>
      <div class="col-6 nameTeam">
        {{ rightName }}
      </div>
    </div>
    <div class="row px-1">
      <div class="col-6 px-0">
        <a
          v-for="(spread, index) in leftElements"
          :key="index"
          class="py-1 select-popup-menu row"
          @click="selectSpread(spread, reff == 'spread' ? 'away' : null)"
          @mouseenter="hoveredIndex = index"
          @mouseleave="hoveredIndex = null"
        >
          <div 
            class="box py-1" 
            :class="{ 
              'box-highlighted': hoveredIndex === index
            }"
          >
            <div class="col-12 p-0">
              <span class="spread-display">
                {{ popup === 'totalPopUp' ? spread : signOdds(spread) }}
              </span>
            </div>
            <div class="col-12 p-0">
              <span class="odds-display">
                {{ findBestOffer(game[left][spread], bidLadderSpread) }}
              </span>
            </div>
          </div>
        </a>
        <div v-if="!bidLadderSpread" class="">
          <button
            class="create-offer-btn box"
            @click="createOffer(reff == 'spread' ? 'awaySpreads' : 'over')"
          >
            Create Offer
          </button>
        </div>
      </div>
      <div class="col-6 px-0 right-column">
        <a
          v-for="(spread, index) in rightElements"
          :key="index"
          class="py-1 select-popup-menu row right-menu-item"
          @click="
            selectSpread(leftElements[index], reff == 'spread' ? 'away' : null)
          "
          @mouseenter="hoveredIndex = index"
          @mouseleave="hoveredIndex = null"
        >
          <div 
            class="box box-right py-1" 
            :class="{ 
              'box-highlighted': hoveredIndex === index
            }"
          >
            <div class="col-12 p-0">
              <span class="spread-display">
                {{ popup === 'totalPopUp' ? spread : signOdds(spread) }}
              </span>
            </div>
            <div class="col-12 p-0">
              <span class="odds-display">
                {{ findBestOffer(game[right][spread], bidLadderSpread) }}
              </span>
            </div>
          </div>
        </a>
        <div v-if="!bidLadderSpread" class="">
          <button
            class="create-offer-btn box"
            @click="createOffer(reff == 'spread' ? 'homeSpreads' : 'under')"
          >
            Create Offer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, onMounted, onBeforeUnmount, ref } from 'vue';
import { findBestOffer, signOdds } from '@/core/utils';

const hoveredIndex = ref(null);
const props = defineProps({
  game: {
    type: Object,
    required: true,
  },
  popup: {
    type: String,
    required: true,
  },
  leftElements: {
    type: Array,
    required: true,
  },
  rightElements: {
    type: Array,
    required: true,
  },
  bidLadderSpread: {
    type: Boolean,
    required: true,
  },
});

onMounted(() => {
  window.addEventListener('click', listener);
});

onBeforeUnmount(() => {
  window.removeEventListener('click', listener);
});

const emit = defineEmits(['selectSpread', 'closeDropdown']);

const reff = computed(() => {
  return props.popup === 'awaySpreadPopUp' ? 'spread' : 'total';
});

const left = computed(() => {
  return props.popup === 'awaySpreadPopUp' ? 'awaySpreads' : 'over';
});

const right = computed(() => {
  return props.popup === 'awaySpreadPopUp' ? 'homeSpreads' : 'under';
});

const leftName = computed(() => {
  return props.popup === 'awaySpreadPopUp'
    ? props.game.participants[0].shortName
    : 'Over';
});

const rightName = computed(() => {
  return props.popup === 'awaySpreadPopUp'
    ? props.game.participants[1].shortName
    : 'Under';
});

function selectSpread(number, homeAway) {
  const payload = { number, homeAway };
  emit('selectSpread', payload);
  emit('closeDropdown');
}

function listener(e = {}) {
  if (!e.target || e.target.className !== 'spread-underline') {
    emit('closeDropdown');
  }
}
</script>

<style scoped lang="scss">
@use 'sass:map';
@use '@/scss/main.scss';

.create-offer-btn {
  width: 70px !important;
  margin: auto !important;
  padding: 5px 0.5rem !important;
  font-size: main.$font-size-xs;
  line-height: inherit;
  color: main.$color-primary !important;
  margin-top: 0.3rem !important;
  margin-bottom: 5px !important;
}

.select-popup {
  text-align: center;
  width: auto;
  font-size: 24px;
  position: absolute;
  left: 50px;
  top: 40px;
  min-width: 10rem;
  background-color: main.$white_01;
  box-shadow: 0 2px 10px main.$black-100;
  z-index: 2;
  cursor: pointer;
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    right: 2px;
    top: 20px;
  }
  &-menu {
    text-decoration: none;
    a,
    div {
      font-size: main.$font-size-sm;
      font-weight: 700;
      display: block;
      color: main.$blue-900;
      span {
        color: main.$blue-300;
      }
      &:hover {
        color: main.$green-700;
        .box-highlighted {
          color: main.$blue-900 !important;
          .spread-display {
            color: main.$blue-900 !important;
          }
        }
      }
    }
  }
}

.select-popup-bidladder {
  text-align: center;
  width: auto !important;
  font-size: 24px;
  position: absolute;
  left: 270px;
  top: 160px;
  min-width: 10rem;
  background-color: main.$white_01;
  box-shadow: 0 2px 10px main.$black-100;
  z-index: 2;
  cursor: pointer;
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    left: 38vw;
    top: 19vh;
    min-width: 8rem;
  }
  &-menu {
    text-decoration: none;
    a,
    div {
      font-size: main.$font-size-sm;
      font-weight: 700;
      display: block;
      color: main.$blue-900;
      span {
        color: main.$blue-300;
      }
      &:hover {
        color: main.$green-700;
        .box-highlighted {
          color: main.$blue-900 !important;
          .spread-display {
            color: main.$blue-900 !important;
          }
        }
      }
    }
  }
}

.spread-display {
  font-size: main.$font-size-sm;
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    font-size: 0.8rem;
  }
}

.odds-display {
  font-size: small;
  color: main.$color-primary_01 !important;
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    font-size: 0.65rem;
  }
}

.box {
  outline: 1px solid main.$blue-1300;
  margin: auto;
  border-radius: 6px;
  min-width: 70px !important;
  background: main.$grey-500 !important;
  box-shadow: 0 2px 2px main.$black-100;
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    min-width: 55px !important;
  }
  &:hover {
    outline: 1px solid main.$blue-100;
  }
}

.nameTeam {
  color: main.$black;
  text-align: center;
  font-size: 12px;
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    font-size: 0.8rem;
  }
}

.right-column {
  pointer-events: auto;
}

.right-menu-item {
  cursor: pointer !important;
  pointer-events: auto !important;

  a,
  div {

    &:hover {
      color: main.$blue-900 !important;
    }
  }
}

.box-right {
  pointer-events: auto;
  cursor: pointer !important;

  &:hover:not(.box-highlighted) {
    outline: 1px solid main.$blue-1300 !important;
  }
}

.box-highlighted {
  outline: 1px solid main.$blue-100 !important;
  text-decoration: underline !important;
  color: main.$blue-900 !important;
  
  .spread-display {
    color: main.$blue-900 !important;
  }
  
  .odds-display {
    color: main.$color-primary_01 !important;
  }
  
  &.box-right {
    &:hover {
      outline: 1px solid main.$blue-100 !important;
    }
  }
}
</style>
